<template>
  <section>
    <bread-crumb></bread-crumb>
    <div class="my-balance">
      <h1>我的余额</h1>
      <div>
        <span>账户余额：</span>
        <p>¥{{ walletInfo.available_balance }}</p>
        <button @click="goToRecharge">充值</button>
      </div>
    </div>

    <div class="business-detail">
      <h1>交易明细</h1>
      <ul>
        <li class="list-title">
          <span v-for="(item,index) in detailTabs" :key="index">{{ item.name }}</span>
        </li>

        <li class="list" v-for="(item,index) in balanceList" :key="index">
          <span>{{ item.create_time }}</span>
          <span>{{ item.describe }}</span>
          <span v-text="item.type== 1 ? '收入' : '支出'"></span>
          <span v-text="item.type== 1 ? '+'+ item.amount: '-' +item.amount"></span>
          <span>{{ item.now_balance }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';
import {getBalanceRecord} from '@/api/personal'
import {mapState, mapActions} from 'vuex';
export default {
  data() {
    	return {
      newsFlag: 0,
      isMgShow: false,
      tabs: [
        {name: '全部'},
        {name: '通知公告'},
        {name: '系统消息'}
      ],
      detailTabs: [
        {name: '交易时间'},
        {name: '项目名称'},
        {name: '资金流向'},
        {name: '发生余额'},
        {name: '账户余额'}
      ],
      body: {
        page_index: 1,
        page_size: 10
      },
      balanceList: []
    };
  },

  created() {
    this.getMyWallet();
    this.getBalanceList();
  },

  computed: {
    	...mapState(['walletInfo']),
  },

  methods: {
    close() {
      this.getMyWallet();
      this.isPayModal = false;
    },

    // 获取钱包余额
    ...mapActions(['getMyWallet']),
    async getBalanceList() {
      const { data, status } = await getBalanceRecord(this.body);
      if (status !== 200) return
      this.balanceList = data.data;
      if (this.balanceList.length) {
        this.body.page_index += 1
      }
    },

    // 去充值
    goToRecharge() {
    	var backUrl = location.href
    	this.$router.push({
    		path: './recharge',
    		query: {
    			url: encodeURIComponent(backUrl)
    		}
    	})
    },
  },

  components: {
	    BreadCrumb
  }
};
</script>

<style lang="scss" scoped>
    h1{
        @include font-style;
        font-size: 20px;
        color: #000000;
        margin-bottom: 28px;
    }
    .my-balance{
        div{
            display: flex;
            align-items: center;
            background: #fff;
            padding-left: 35px;
            border-radius: 4px;
            height: 88px;
            span{
                @include font-style;
                font-size: 14px;
                color: #303133;
            }
            p{
                @include font-style;
                font-size: 20px;
                font-weight: bold;
                color: #FF8D1C;
                margin-left: 156px;
                margin-right: 194px;
            }
            button{
                cursor: pointer;
                width: 98px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #FF8D1C;
                box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.16);
                border-radius: 5px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .business-detail{
        margin-top: 28px;
        ul{
            background: #FFFFFF;
            box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.16);
            border-radius: 5px;
            .list-title{
                @include font-style;
                padding: 20px 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                color: #333333;
                span{
                    width: 20%;
                    text-align: center
                }

            }
            .list{
                @include font-style;
                padding: 20px 0 20px 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                color: #999999;
                span{
                    width: 20%;
                    text-align: center
                }
            }
            .list:nth-child(odd){
                background: #fff;
            }
            .list:nth-child(even){
                background: #FFF3E6;
            }
        }

    }
</style>